module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'gr-10': _vm.isSimulation,
      'gr-12': !_vm.isSimulation
    }
  }, [_c('div', {
    staticClass: "row question",
    class: _vm.questionClass
  }, [(_vm.question.type === 'BOOLEAN') ? _c('question-switch', {
    class: {
      'no-print': _vm.question.showInReportAnswers === false
    },
    attrs: {
      "question": _vm.question,
      "categoryId": _vm.categoryId,
      "questionCommentTitle": _vm.questionCommentTitle,
      "questionCommentTooltip": _vm.questionCommentTooltip,
      "is-simulation": _vm.isSimulation
    }
  }) : _vm._e(), (_vm.question.type === 'STRING') ? _c('question-input', {
    class: {
      'no-print': _vm.question.showInReportAnswers === false
    },
    attrs: {
      "question": _vm.question,
      "categoryId": _vm.categoryId,
      "is-simulation": _vm.isSimulation
    }
  }) : _vm._e(), (_vm.question.type === 'NUMBER') ? _c('question-number', {
    class: {
      'no-print': _vm.question.showInReportAnswers === false
    },
    attrs: {
      "question": _vm.question,
      "categoryId": _vm.categoryId,
      "is-simulation": _vm.isSimulation
    }
  }) : _vm._e(), (_vm.question.type === 'TEXTAREA') ? _c('question-textarea', {
    class: {
      'no-print': _vm.question.showInReportAnswers === false
    },
    attrs: {
      "question": _vm.question,
      "categoryId": _vm.categoryId,
      "is-simulation": _vm.isSimulation
    }
  }) : _vm._e(), (_vm.question.type === 'COUNTRY') ? _c('question-select', {
    class: {
      'no-print': _vm.question.showInReportAnswers === false
    },
    attrs: {
      "question": _vm.question,
      "categoryId": _vm.categoryId,
      "is-simulation": _vm.isSimulation
    }
  }) : _vm._e()], 1)]), (_vm.isSimulation) ? _c('div', {
    staticClass: "gr-2"
  }, [_c('el-popover', {
    ref: "explained",
    attrs: {
      "placement": "top-start",
      "width": "320",
      "trigger": "hover",
      "effect": "dark"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.scoreExplanation)
    }
  })]), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:explained",
      arg: "explained"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "gr-6 pt-15 txt-center"
  }, [(_vm.question.appliedPenalty != 0) ? _c('div', [_vm._v(_vm._s(_vm.question.appliedPenalty))]) : _c('div', [_vm._v("\n                -\n              ")])]), _c('div', {
    staticClass: "gr-6 pt-15 txt-center"
  }, [(_vm.question.reductionFactor != 1) ? _c('div', [_vm._v(_vm._s(_vm.question.reductionFactor))]) : _c('div', [_vm._v("\n                  -\n              ")])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-148f976a","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-148f976a","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question.vue
// module chunks = 0